import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AppThunk} from '../../app/store';
import {authenticationState, UserGETResponse} from "../../utils/types";
import {getUser} from "../../app/protected_api";
import Cookies from "js-cookie";
import {LOGIN_SESSION_KEY} from "../../app/settings";
import {setError} from './authenticationErrorSlice';

export const loggedIn = Cookies.get(LOGIN_SESSION_KEY) === 'true';

const initialState: authenticationState = {
    user: null,
    nonResearcherSFUComputingID: null
}

export const authenticationSlice = createSlice({
    name: 'authentication',
    initialState,
    reducers: {
        userLoadedSuccess: (state, action: PayloadAction<UserGETResponse>) => {
            state.user = action.payload;
            state.nonResearcherSFUComputingID = null;
        },
        userLoadedFailure: (state, action: PayloadAction<string>) => {
            state.user = null;
            state.nonResearcherSFUComputingID = action.payload;
        },
    },
});

export const {
    userLoadedSuccess,
    userLoadedFailure
} = authenticationSlice.actions;

export default authenticationSlice;

export const loadUser = (): AppThunk => async dispatch => {
    try {
        const user = await getUser();
        dispatch(userLoadedSuccess(user));
        dispatch(setError(null));
    } catch (err) {
        dispatch(userLoadedFailure(err?.response?.data?.sfu_computing_id));
        dispatch(setError(err?.response?.data?.message));
    }
};